import React from 'react';
import moment from 'moment/moment';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { DatePropType } from './helpers/common';
import './_SingleDateSelectedValue.scss';

/**
 *  Component of the selected value in the date picker input
 */
const SingleDateSelectedValue = ({ value, placeholder, format }) => {
  return (
    <span
      className={classNames('SingleDateSelectorValue', {
        'SingleDateSelectorValue--picked': value
      })}
    >
      {value ? moment(value).format(format) : placeholder}
    </span>
  );
};

SingleDateSelectedValue.propTypes = {
  /**
   * the date selected value
   */
  value: DatePropType,
  /**
   * placeholder text when there's no selected value
   */
  placeholder: PropTypes.string,
  /**
   * The date format to display the value with
   */
  format: PropTypes.string
};

export default SingleDateSelectedValue;
